import { Component } from '@angular/core';

@Component({
  selector: 'app-progetti',
  standalone: false,
  templateUrl: './progetti.component.html',
  styleUrl: './progetti.component.scss'
})
export class ProgettiComponent {

}
